import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { BillingserviceService } from 'app/billing/billingService.service';
import { ServiceList } from 'app/billing/Models/billing.Models';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';
@Component({
  selector: 'app-investigation-services',
  templateUrl: './investigation-services.component.html',
  styleUrls: ['./investigation-services.component.scss']
})
export class InvestigationServicesComponent implements OnInit {
  private destroyinveservice$: Subject<boolean> = new Subject<boolean>();
  private filtervalue: any;
  private catselected = -1;
  // private depselected = 1;
  stype:any;
  private deptCheck: boolean = false;
  private catCheck: boolean = false;
  private serCheck: boolean = true;
  private todaysdate = new Date();
  private displayedColumns: string[] = ['serviceName', 'categoryName', 'deptName', 'rate', 'maxDiscountLimit', 'serviceCharge', 'discount'];
  private dataSource = new MatTableDataSource<ServiceList>();
  private selection = new SelectionModel<ServiceList>(true, []);
  //private surgerydepartments_ds = new MatTableDataSource();
  //private surgerycategories_ds = new MatTableDataSource();
  private SelectedServiceArray: any = [];
  //dataSource=new MatTableDataSource();
  // displayedColumns_surgerydepartments: string[] = ['surgeryDeptName'];
  // displayedColumns_surgerycategories: string[] = ['surgeryCatName'];
  constructor(private speachTxt: VoiceRecognitionService,
    private authService: AuthService, private dashboardService: DashboardService, private dialogRef: MatDialogRef<InvestigationServicesComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,
    private opdvisitService: OpdVisitService,
    private billingservice: BillingserviceService, private emrService: EMRService) {
    //  this.getDepartmentList();
    this.speachTxt.init();
  }


  ngOnInit(): void {
    this.stype ='S';
    this.SelectedServiceArray = [];
    // this.catCheck = true;
    this.speachTxt.IStext = '';
    this.getConfiglist();
    this.dataSource.filterPredicate = function (data, filterValue: string): boolean {
      return data.serviceName.toLowerCase().includes(filterValue) || data.categoryName.toLowerCase().includes(filterValue) || data.deptName.toString().includes(filterValue)
        || data.rate.toString().includes(filterValue) || data.maxDiscountLimit.toString().includes(filterValue) || data.serviceCharge.toString().includes(filterValue) || data.discount.toString().includes(filterValue);
    };
  }
  
  searchType(stype:any){
    this.stype =stype;
  }
  //get depatment list
  getDepartmentList() {
    this.billingservice.getDepartmentList().pipe(takeUntil(this.destroyinveservice$)).subscribe(data => this.successdepart(data), err => this.failed_depart(err))
  }


  successdepart(data) {
    // this.surgerydepartments_ds.data = data;
    this.getCateogryList(data[0].deptId)
  }
  failed_depart(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  getCateogryList(deptid) {
    this.billingservice.getCateogryList(deptid).pipe(takeUntil(this.destroyinveservice$)).subscribe(data => this.successCategory(data, deptid), err => this.failed_category(err))
  }

  successCategory(data, deptid) {
    // this.surgerycategories_ds.data = data;
    var catid = data[0].categoryId;
  }
  failed_category(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  //get rate list 
  // getServiceList(DepartId:any,catid:any){

  //   this.billingservice.servicelist=[];
  //    let CategoryId=0;
  //    let RateListId=1;
  //    let RateTypeId= 1;
  //    let DepartmentId=0;

  //    console.log('catid',CategoryId,'rateList',RateListId,'ratetypeId',RateTypeId,'depid',DepartmentId)
  //    this.billingservice.getserviceByDepartmentId(DepartmentId,CategoryId,RateListId,RateTypeId).pipe(takeUntil(this.destroy$)).subscribe((data: any[])=>{

  //     this.billingservice.servicelist = data;
  //     this.dataSource.data=this.billingservice.servicelist;
  //      console.log('all services',this.billingservice.servicelist);
  //   })
  // }
  Checkedname: any;
  deptChange(event, name) {
    if (name == 'dept') {
      this.deptCheck = event.checked;
    } else if (name == 'cat') {
      this.catCheck = event.checked;
    } else if (name == 'ser') {
      this.serCheck = event.checked;
    }


  }
  gettop_200byname(sname: any, type) {

    switch (type) {
      case (1): {
        if (sname.length > 0) {
          this.getServiceListName(sname);
        }
        break;

      }
      case (2): {
        if (sname.length > 3) {
          this.getServiceListName(sname);
        }
        break;
      }
    }

  }
  getServiceListName(Searchname: any) {
    this.billingservice.servicelist = [];
    let CategoryId;
    let RateListId = 1;
    let RateTypeId = 1;
    let DepartmentId;
    let serviceId;
    //  if(this.deptCheck == true && this.catCheck == true && this.serCheck == true){
    //   DepartmentId='~';
    //   CategoryId='~';
    //   serviceId='~';
    //  }else{
    if (this.deptCheck == true) {
      DepartmentId = Searchname;
    } else {
      DepartmentId = '~';
    }
    if (this.catCheck == true) {
      CategoryId = Searchname;
    } else {
      CategoryId = '~';
    }
    if (this.serCheck == true) {
      serviceId = Searchname;
    } else {
      serviceId = '~';
    }
    //  }  

    this.billingservice.getserviceByDepartmentIdByCatByService(RateListId, RateTypeId, DepartmentId, CategoryId, serviceId,this.stype).pipe(takeUntil(this.destroyinveservice$)).subscribe((data: any[]) => {

      this.billingservice.servicelist = data;
      this.dataSource.data = this.billingservice.servicelist;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  getConfiglist() {
    this.billingservice.billserviceConfig = {};
    let BranchId = this.authService.Loggeduser.branchid;
    //  let BranchId=1;
    this.billingservice.get_Bill_Congigrationlist(BranchId).pipe(takeUntil(this.destroyinveservice$)).
      subscribe(data => this.success_config(data), err => this.failed_config(err));
  }
  success_config(data) {
    // console.log('billing confrigration',data);
    for (let i = 0; i < this.billingservice.servicelist.length; i++) {
      const element = this.billingservice.servicelist[i];
      if (element.serviceId === data[0].fK_FollowupServiceId) {
        this.emrService.selectedInvestigationRow = this.billingservice.servicelist[i];
        // console.log('default selected service',this.billingservice.selectedServiceRow)
      }

    }


  }

  failed_config(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  filtersurgerylist(row) {
    let catid = row.categoryId;
    this.catselected = catid;
    var depatid = row.deptId;
    // this.getServiceList(depatid,this.catselected);
  }

  applyFilter_grid(filterValue) {

    this.dataSource.filter = filterValue.trim().toLowerCase();

  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data?.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);
    var checkarraydata = this.SelectedServiceArray.filter(item => item.serviceId == row.serviceId);
    if (checkarraydata.length > 0) {
      this.SelectedServiceArray = this.SelectedServiceArray.filter(item => item.serviceId != row.serviceId);
    } else {
      this.SelectedServiceArray.push(row);
    }

    this.SelectedServiceArray = this.SelectedServiceArray.reduce((unique, o) => {
      if (!unique.some(obj => obj.serviceName === o.serviceName && obj.FK_ServiceId === o.FK_ServiceId)) {
        unique.push(o);
      }
      return unique;
    }, []);


  }

  removeRow(x) {
    const index: number = this.SelectedServiceArray.indexOf(x);
    if (index !== -1) {
      this.SelectedServiceArray.splice(index, 1);
      this.selection.toggle(x);
    }


  }

  saveServices() {
    this.emrService.selectedInvestigationRow = this.SelectedServiceArray;
    this.dialogRef.close(this.SelectedServiceArray);
    this.speachTxt.IStext = '';
  }
  closedialog() {
    this.SelectedServiceArray = [];
    this.dialogRef.close(this.SelectedServiceArray);
     this.emrService.selectedInvestigationRow = []; 
    this.speachTxt.IStext = '';
  }


  getrowdata(row: any) {
    this.SelectedServiceArray.push(row);
    this.emrService.selectedInvestigationRow = this.SelectedServiceArray;
    this.dashboardService.openSnackBar("Service added successfully", "OK");
    this.dialogRef.close(this.SelectedServiceArray);

  }

  addsurgery() {
    this.billingservice.selectedServiceRow = this.selection.selected;
    this.dialogRef.close();
  }
  startService() {
    this.speachTxt.IStext = '';
    this.speachTxt.start('Investigation Search');
  }

  stopService() {
    this.speachTxt.stop('Investigation Search');
    this.gettop_200byname(this.speachTxt.IStext, 2)
  }
  ngOnDestroy() {
    this.destroyinveservice$.next(true);
    this.destroyinveservice$.unsubscribe();
    this.speachTxt.IStext = null;
    this.SelectedServiceArray = null;
    this.displayedColumns = null;
    this.dataSource = null;
    this.selection = null;
  }
}
